import type {Voice} from "@khan/guide-types";

/**
 * Represents a single chunk of audio message.
 */
export interface AudioSampleTranscript {
    welcome: string;
    error: string;
}

// sync-start:guide-voices 818981658 https://github.com/Khan/webapp/blob/master/libs/guide/utils/src/guide-voices.ts
export const audioSampleTranscripts: Record<Voice, AudioSampleTranscript> = {
    "lmnt:khanmigo-m-1:en": {
        welcome:
            "Hello I'm Khanmigo. I use artificial intelligence to help you learn on Khan Academy.",
        error: "Sorry, I am experiencing technical problems. Please try again later.",
    },

    "lmnt:khanmigo-f-2:en": {
        welcome:
            "Hello I'm Khanmigo. I use artificial intelligence to help you learn on Khan Academy.",
        error: "Sorry, I am experiencing technical problems. Please try again later.",
    },
    "lmnt:khanmigo-nb-2:en": {
        welcome:
            "Hello I'm Khanmigo. I use artificial intelligence to help you learn on Khan Academy.",
        error: "Sorry, I am experiencing technical problems. Please try again later.",
    },
    "lmnt:khanmigo-m-1:es": {
        welcome:
            "Hola soy Khanmigo. Utilizo inteligencia artificial para ayudarte a aprender en Khan Academy.",
        error: "Lo siento, estoy teniendo problemas t\u00e9cnicos. Por favor, int\u00e9ntelo de nuevo m\u00e1s tarde.",
    },
    "lmnt:khanmigo-f-2:es": {
        welcome:
            "Hola soy Khanmigo. Utilizo inteligencia artificial para ayudarte a aprender en Khan Academy.",
        error: "Lo siento, estoy teniendo problemas t\u00e9cnicos. Por favor, int\u00e9ntelo de nuevo m\u00e1s tarde.",
    },
    "lmnt:khanmigo-nb-2:es": {
        welcome:
            "Hola soy Khanmigo. Utilizo inteligencia artificial para ayudarte a aprender en Khan Academy.",
        error: "Lo siento, estoy teniendo problemas t\u00e9cnicos. Por favor, int\u00e9ntelo de nuevo m\u00e1s tarde.",
    },
    "lmnt:khanmigo-m-1:pt": {
        welcome:
            "Ol\u00e1, meu nome \u00e9 Khanmigo. Eu uso intelig\u00eancia artificial para ajudar voc\u00ea a aprender na Khan Academy.",
        error: "Desculpe, estou enfrentando problemas t\u00e9cnicos. Por favor, tente novamente mais tarde.",
    },
    "lmnt:khanmigo-f-2:pt": {
        welcome:
            "Ol\u00e1, meu nome \u00e9 Khanmigo. Eu uso intelig\u00eancia artificial para ajudar voc\u00ea a aprender na Khan Academy.",
        error: "Desculpe, estou enfrentando problemas t\u00e9cnicos. Por favor, tente novamente mais tarde.",
    },
    "lmnt:khanmigo-nb-2:pt": {
        welcome:
            "Ol\u00e1, meu nome \u00e9 Khanmigo. Eu uso intelig\u00eancia artificial para ajudar voc\u00ea a aprender na Khan Academy.",
        error: "Desculpe, estou enfrentando problemas t\u00e9cnicos. Por favor, tente novamente mais tarde.",
    },
    "lmnt:khanmigo-m-1:hi": {
        welcome:
            "नमस्ते, मैं खानमिगो हूं। खान अकादमी में आपको सीखने में मदद करने के लिए मैं कृत्रिम बुद्धिमत्ता का उपयोग करता हूँ।",
        error: "क्षमा करें, मुझे तकनीकी समस्याएँ आ रही हैं। कृपया बाद में पुन: प्रयास करें।",
    },
    "lmnt:khanmigo-f-2:hi": {
        welcome:
            "नमस्ते, मैं खानमिगो हूं। खान अकादमी में आपको सीखने में मदद करने के लिए मैं कृत्रिम बुद्धिमत्ता का उपयोग करता हूँ।",
        error: "क्षमा करें, मुझे तकनीकी समस्याएँ आ रही हैं। कृपया बाद में पुन: प्रयास करें।",
    },
    "lmnt:khanmigo-nb-2:hi": {
        welcome:
            "नमस्ते, मैं खानमिगो हूं। खान अकादमी में आपको सीखने में मदद करने के लिए मैं कृत्रिम बुद्धिमत्ता का उपयोग करता हूँ।",
        error: "क्षमा करें, मुझे तकनीकी समस्याएँ आ रही हैं। कृपया बाद में पुन: प्रयास करें।",
    },
};
// sync-end:guide-voices
